/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * FilterIcon
 */
export default class FilterIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M22.9 2.6c-.2-.4-.5-.6-.9-.6H2c-.4 0-.7.2-.9.6-.2.4-.1.7.1 1L9 12.9V19c0 .4.2.7.6.9l4 2c.1.1.2.1.4.1s.4 0 .5-.1c.3-.2.5-.5.5-.9v-8.1l7.8-9.2c.2-.4.3-.8.1-1.1zm-9.7 9.3c-.1.1-.2.4-.2.6v6.9l-2-1v-5.9c0-.2-.1-.5-.2-.6L4.1 4h15.7l-6.6 7.9z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

